import { EventLayoutContext } from "layouts/EventLayout/types";
import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";

import { Layout } from "../../../components/styleguide";

import styles from "./styles.module.less";

export default function ItineraryLayout() {
  const { forum } = useOutletContext<EventLayoutContext>();
  return (
    <div className={styles.container}>
      <Layout.Content>
        <Outlet context={{ forum }} />
      </Layout.Content>
    </div>
  );
}
